<fgb-banner [pageName]="'terms.page.title'"></fgb-banner>
<fgb-page-header [pageTitle]="'terms.page.title'" [showBalance]="false" [backButtonLink]="'/'"/>
<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="pt-lg-4">
        <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <fgbcl-loading [color]="'black'"></fgbcl-loading>
</ng-template>
